import type { IMockStore } from '@graphql-tools/mock';

import ontologySpecReqs from './ontologySuggestions/OntologySpecReqs';
import SearchKeywordSuggestions from './searchKeywordSuggestions/SearchKeywordSuggestions';

const mockResolvers = (_mockStore: IMockStore) => ({
  SearchKeywordSuggestions,
  Query: {
    ontologySpecReqs,
  },
});

// eslint-disable-next-line import/no-default-export
export default mockResolvers;
